import { useQuery } from "@tanstack/react-query";
import { UseFormReturn, useWatch } from "react-hook-form";

import rewardCore from "../core/reward.core";
import { RewardListFilter } from "../types/reward";

export default function useRewardQuery(methods: UseFormReturn<RewardListFilter, any>) {
  const [pageSize, page, customerId] = useWatch({
    name: ["pageSize", "page", "customerId"],
    control: methods.control,
  });

  return useQuery({
    queryKey: ["rewards", page, pageSize, customerId],
    queryFn: (context) =>
      rewardCore.loadRewards({
        paging: {
          page: context.queryKey[1] as number,
          size: context.queryKey[2] as number,
        },
        userIds: customerId ? [customerId] : [],
      }),
  });
}
